import {Badge} from "@mantine/core";
import {I18n} from "@aws-amplify/core";

// Theme colour names, not hex, so light and dark both work (§2). The one sync-status
// badge for the module: the table column and the detail card both render it.
const colors: { [key: string]: string } = {
    'Synced': 'green',
    'Pending': 'yellow',
    'Failed': 'red',
    'Conflict': 'orange',
};

export const SyncStatusBadge = ({status}: { status?: string | null }) => (
    <Badge color={status ? colors[status] ?? 'gray' : 'gray'} variant='light'>
        {status ? I18n.get(status) : '—'}
    </Badge>
);
